export class ProfessionalStep2FormResultKeys {
    static readonly PHONE_EXT = 'form_professional_step_2_field_phone_ext';
    static readonly PHONE = 'form_professional_step_2_field_phone';
    static readonly LNG = 'form_professional_step_2_field_correspondence_lang';
    static readonly FIRST_NAME = 'form_professional_step_2_field_first_name';
    static readonly LAST_NAME = 'form_professional_step_2_field_last_name';
    static readonly EMAIL = 'form_professional_step_2_field_email';
    static readonly PROFESSION = 'form_professional_step_2_field_profession';
    static readonly REASON = 'form_professional_step_2_field_register_reason';
    static readonly REASON_OTHER = 'form_professional_step_2_field_reason_other';
    static readonly COMMENT = 'form_professional_step_2_field_comment';
    static readonly ENTERPRISE_NUMBER = 'form_professional_step_2_field_enterprise_number';
    static readonly NUMBER = 'form_professional_step_2_field_number';
    static readonly TPS = 'form_professional_step_2_field_enterprise_tps';
    static readonly RT = 'form_professional_step_2_field_enterprise_rt';
    static readonly ISSUER = 'form_professional_step_2_field_issuer';
    static readonly ISSUE_DATE = 'form_professional_step_2_field_issue_date';
}

export interface IProfessionalStep2FormResultModel {
    form_professional_step_2_field_phone_ext: string;
    form_professional_step_2_field_phone: string;
    form_professional_step_2_field_correspondence_lang: boolean;
    form_professional_step_2_field_profession: string;
    form_professional_step_2_field_register_reason: string;
    form_professional_step_2_field_reason_other: string;
    form_professional_step_2_field_comment: string;
    form_professional_step_2_field_enterprise_number: string;
    form_professional_step_2_field_enterprise_tps: string;
    form_professional_step_2_field_enterprise_rt: string;
    form_professional_step_2_field_issuer: string;
    form_professional_step_2_field_number: string;
    form_professional_step_2_field_last_name: string;
    form_professional_step_2_field_first_name: string;
    form_professional_step_2_field_email: string;
    form_professional_step_2_field_issue_date: string;
}
